import { Injectable, NgZone } from "@angular/core";
import { Subject, fromEvent, merge, timer, Subscription } from "rxjs";
import { switchMap } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class IdleService {
  private idleTimeout = 30000; // 30 segundos sin interacción
  private idle$ = new Subject<void>();
  private active$ = new Subject<void>();
  private subscription!: Subscription | any;

  onIdle = this.idle$.asObservable();
  onActive = this.active$.asObservable();

  constructor(private ngZone: NgZone) {}

  private manualReset$ = new Subject<void>();

  startWatching() {
    // Emitimos active al arrancar
    this.ngZone.run(() => this.active$.next());

    this.ngZone.runOutsideAngular(() => {
      const userEvents = merge(
        fromEvent(window, "mousemove"),
        fromEvent(window, "touchstart"),
        fromEvent(window, "keydown")
      );

      const activityEvents = merge(userEvents, this.manualReset$);

      this.subscription = activityEvents
        .pipe(
          switchMap(() => {
            this.ngZone.run(() => this.active$.next());
            return timer(this.idleTimeout);
          })
        )
        .subscribe(() => {
          this.ngZone.run(() => this.idle$.next());
        });
    });
  }

  resetIdleTimer() {
    this.manualReset$.next();
  }

  stopWatching() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }

    // También completamos el Subject manual para evitar fugas
    // si no piensas volver a usar el servicio.
    if (this.manualReset$ && !this.manualReset$.closed) {
      this.manualReset$.complete();
    }
  }
}
